import styles from './PromotionBadge.module.css';

import { Present } from '../../icons';
import type { ColorName } from '../../styles';
import { Flex } from '../Flex';
import { Text } from '../Text';

export type PromotionBadgeProps = {
  text: string;
  backgroundColor?: ColorName;
  textColor?: ColorName;
};

export const PromotionBadge = ({
  text,
  backgroundColor = 'Kale0',
  textColor = 'Kale3',
}: PromotionBadgeProps) => {
  return (
    <Flex
      alignItems="center"
      gap="xs"
      backgroundColor={backgroundColor}
      borderRadius="sm"
      className={styles.promoBadge}
    >
      <Present
        size={16}
        baseColor={textColor}
        className={styles.promoBadgeIcon}
      />
      <Text
        as="p"
        variant="heading-12"
        weight="semibold"
        color={textColor}
        spacing={0}
      >
        {text}
      </Text>
    </Flex>
  );
};
